import React, { FC, ReactNode, useContext } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Content from '../Content/Content';
import WrapperOverlay from './WrapperOverlay';
import HeaderRoutes from '../Header/HeaderRoutes';
import FooterRoutes from '../Footer/FooterRoutes';
import ThemeContext from '../../contexts/themeContext';
import { useLocation } from 'react-router-dom';
import { formView } from '../../menu';
import { Toaster } from 'react-hot-toast';

interface IWrapperContainerProps {
	children: ReactNode;
	className?: string;
}

export const WrapperContainer: FC<IWrapperContainerProps> = ({ children, className, ...props }) => {
	const { rightPanel } = useContext(ThemeContext);
	return (
		<div
			className={classNames(
				'wrapper',
				{ 'wrapper-right-panel-active': rightPanel },
				className,
			)}
			// eslint-disable-next-line react/jsx-props-no-spreading
			{...props}>
			{children}
		</div>
	);
};
WrapperContainer.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};
WrapperContainer.defaultProps = {
	className: undefined,
};

const Wrapper = () => {
	const location = useLocation();

	return (
		<>
			{location.pathname.includes('/process') || location.pathname.includes('/verify')  ? (
				<>
					<Content />
				</>
			) : (
				<>
					<WrapperContainer>
						<Toaster position='top-right' />
						<HeaderRoutes />
						<Content />
						<FooterRoutes />
					</WrapperContainer>
					<WrapperOverlay />
				</>
			)}
		</>
	);
};

export default Wrapper;
